import { render, staticRenderFns } from "./detail_list.vue?vue&type=template&id=93f2f904&scoped=true"
import script from "./detail_list.vue?vue&type=script&lang=js"
export * from "./detail_list.vue?vue&type=script&lang=js"
import style0 from "./detail_list.vue?vue&type=style&index=0&id=93f2f904&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93f2f904",
  null
  
)

export default component.exports